import styled from 'styled-components';

export const HeaderContainer = styled.div<{
  $denseFormat?: boolean;
  $isFirst?: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing(1)};

  margin: ${({ theme, $denseFormat, $isFirst }) =>
    $denseFormat
      ? `0 ${theme.spacing(1.5)} 0 ${theme.spacing(3.5)}`
      : `${$isFirst ? theme.spacing(2.5) : theme.spacing(4)} ${theme.spacing(1.5)} ${theme.spacing(1.5)} ${theme.spacing(3.5)}`};
  padding: ${({ theme }) => `${theme.spacing(2)} 0`};

  border-bottom: 1px solid ${({ theme }) => theme.palette.divider};
`;

export const HoverActions = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};

  opacity: 0;
  pointer-events: none;
  transition: opacity 200ms ease-in-out;

  ${HeaderContainer}:hover & {
    opacity: 1;
    pointer-events: auto;
  }
`;

export const ActionsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1.6)};
`;
